import { trackScrollToEstimationBlock } from './tracking';

export default [
  '$scope',
  'homeownerService',
  'config',
  function($scope, homeownerService, config) {
    this.isOwner = homeownerService.userCanPublishAdAsHomeownerInCurrentCategory;

    this.showPriceEstimator = false;
    this.isEstimationBlockScrollTracked = false;

    const updateBannerVisibility = () => {
      document.removeEventListener('scroll', trackEstimatorVisibilityByScroll);

      this.isEstimationBlockScrollTracked = false;

      const isValuationEstimateEnabled = !!config.get('addForm.ValuationPriceEstimate.Enabled');

      const isFlatRentOrSale =
        this.categoryInfo.objectType === 'flat' &&
        (this.categoryInfo.dealType === 'rent' || this.categoryInfo.dealType === 'sale');

      this.showPriceEstimator = isFlatRentOrSale && isValuationEstimateEnabled;

      if (this.showPriceEstimator) {
        document.addEventListener('scroll', trackEstimatorVisibilityByScroll);
      }
    };

    const trackEstimatorVisibilityByScroll = () => {
      const priceAndEstimationBlock = document.getElementById('price-and-deal-terms');

      if (priceAndEstimationBlock) {
        const rect = priceAndEstimationBlock.getBoundingClientRect();

        const isVisible = rect.bottom <= window.innerHeight;

        if (isVisible && !this.isEstimationBlockScrollTracked) {
          trackScrollToEstimationBlock();
          this.isEstimationBlockScrollTracked = true;
        }
      }
    }

    $scope.$watchGroup([() => this.categoryInfo.objectType, () => this.categoryInfo.dealType], updateBannerVisibility);
  }
];
